
import { LinkedList } from 'vs/base/common/linkedList';
import { IContextKey, IContextKeyService } from 'vs/platform/contextkey/common/contextkey';
import { IInteractiveEditorService, IInteractiveEditorSessionProvider, CTX_INTERACTIVE_EDITOR_HAS_PROVIDER } from './interactiveEditor';

export class InteractiveEditorServiceImpl implements IInteractiveEditorService {

	declare _serviceBrand: undefined;

	private readonly _entries = new LinkedList<IInteractiveEditorSessionProvider>();

	private readonly _ctxHasProvider: IContextKey<boolean>;

	constructor(@IContextKeyService contextKeyService: IContextKeyService) {
		this._ctxHasProvider = CTX_INTERACTIVE_EDITOR_HAS_PROVIDER.bindTo(contextKeyService);
	}

	getAll() {
		return [...this._entries];
	}
}
